import {inject, Injectable, signal} from '@angular/core';
import {ValidationFilesService} from "./validation-files.service";
import {FileParams, FileTypeName} from "../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class PreviewFileUrlsStateService {
  private validationFilesService: ValidationFilesService = inject(ValidationFilesService);
  private _previewFileUrlsState = signal<Record<string, Array<number>>>({});
  public previewFileUrlsState = this._previewFileUrlsState.asReadonly();

  public setPreviewFileUrlsState(previewFileUrlsState: Record<FileTypeName, Array<FileParams>>) {
    const newState = Object.fromEntries(
      Object.entries(previewFileUrlsState).map(([fileType, filesArray]) => [
        fileType,
        filesArray.reduce((ids, fileCard) => {
          if (this.validationFilesService.isImage(fileCard.filename)) {
            ids.push(fileCard.id);
          }
          return ids;
        }, [] as number[])
      ])
    ) as Record<FileTypeName, number[]>;

    this._previewFileUrlsState.set(newState);
  }

  public addPreviewFileUrl(fileType: FileTypeName, fileId: number): void {
    this._previewFileUrlsState.update(currentState => ({
      ...currentState,
      [fileType]: currentState[fileType]
        ? currentState[fileType].includes(fileId)
          ? currentState[fileType]
          : [...currentState[fileType], fileId]
        : [fileId]
    }));
  }

  public deletePreviewFileUrlById(id: number) {
    this._previewFileUrlsState.update(current =>
      Object.entries(current).reduce((acc, [fileType, ids]) => {
        acc[fileType as FileTypeName] = ids.filter(fileId => fileId !== id);
        return acc;
      }, {} as Record<FileTypeName, number[]>)
    );
  }

  public resetPreviewFileUrlsState(): void {
    this._previewFileUrlsState.set({});
  }
}
